"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KmsServiceNS = void 0;
var KmsServiceNS;
(function (KmsServiceNS) {
    KmsServiceNS.KMS_SERVICE_ID = Symbol.for("KmsService");
})(KmsServiceNS = exports.KmsServiceNS || (exports.KmsServiceNS = {}));
//# sourceMappingURL=kms.types.js.map